import Icon from '@mercadoni/sinister/dist/cjs/mystiqueIcon'
import { memo } from 'react'
import styled from 'styled-components'

const ArrowStyled = styled.button`
  position: absolute;
  cursor: pointer;
  top: 40%;
  padding: 0;
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 50%;
  background-color: var(--color-white);
  box-shadow: var(--shadow-boxShadow);
  @media screen and (max-width: 576px) {
    display: none;
  }
`

const LeftArrowStyled = styled(ArrowStyled)<{
  onClick: (value: number) => void
}>`
  left: 0;
`

const RightArrowStyled = styled(ArrowStyled)<{
  onClick: (value: number) => void
}>`
  right: 0;
`
const IconB = ({ icon }: { icon: string }) => (
  <Icon icon={icon} aria-hidden size="24" stroke="var(--color-primary)" />
)
const CommonIcon = memo(IconB)

const Arrows = ({ onClick }: { onClick: (value: number) => void }) => {
  return (
    <>
      <LeftArrowStyled onClick={() => onClick(-1)}>
        <CommonIcon icon="arrow-left" />
      </LeftArrowStyled>
      <RightArrowStyled onClick={() => onClick(1)}>
        <CommonIcon icon="arrow-right" />
      </RightArrowStyled>
    </>
  )
}

export default memo(Arrows)
